import React from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import Header from "../components/Header"
import EatingHistory from "../components/EatingHistory"
import Return from "../components/Forum/Return"

import { deleteDataFromApi, registerAction } from '../api'
import { PortalContext } from '../AuthenticatedUser'
import HighlightedMessage from '../components/HighlightedMessage'
import Attention from "../images/sun.svg"
import Button from '../components/Button'
import Lazy from '../images/lazy-animal.svg'
import WeeklyRanking from '../components/WeeklyRanking'
import { differenceInDays, differenceInHours, differenceInMinutes, nextSunday, nextWednesday } from 'date-fns'

export default function UserLeague() {
  
  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const [type, setType] = React.useState('all')
  
  const {
    sequenceLength,
    eating,
    league,
    loadEatingDataFromAPI,
    exercise,
    loadExerciseDataFromAPI,
    auth, 
    cookies } = React.useContext(PortalContext);
  
  const navigate = useNavigate()
  const location = useLocation()
  
  React.useEffect(() => {
    if (!cookies.get("userId")) {
      cookies.set('pageOfInterest', '/eating', { path: '/' })
      navigate("/family")
    } else {
      if (!eating || !eating?.history) {
        loadEatingDataFromAPI()
      }
      if (!exercise || !exercise?.history) {
        loadExerciseDataFromAPI()
      }
    }
    registerAction(+cookies.get("userId"), "leaguepage", auth, cookies)
  }, []);

  let historyItems = []


  if (exercise?.history && eating?.history) {

    const exerciseHistoryFiltered = exercise.history.filter((food, i, arr) => arr.findIndex(obj2 => (obj2.id === food.id)) === i)
    const mealsHistoryFiltered = eating.history.filter((food, i, arr) => arr.findIndex(obj2 => (obj2.id === food.id)) === i)
    
    if (type === "all") {
      historyItems = historyItems.concat(mealsHistoryFiltered)
      historyItems = historyItems.concat(exerciseHistoryFiltered)
    } else if (type === "eating") {
      historyItems = historyItems.concat(mealsHistoryFiltered)
    } else if (type === "exercise") {
      historyItems = historyItems.concat(exerciseHistoryFiltered)
    }
  }
  
  //const removeFood = (id) => {
  //  console.log(`removing food ${id}`)
  //  deleteDataFromApi({"item_id": +id, "id": +cookies.get("userId")}, 'food', auth, cookies)
  // setMealsHistory(prev => prev.filter(item => item.id !== id))
  //}
  
  //const removeExercise = (id) => {
  //  console.log(`removing exercise ${id}`)
  //  deleteDataFromApi({"item_id": +id, "id": +cookies.get("userId")}, 'exercise', auth, cookies)
  //  setExerciseHistory(prev => prev.filter(item => item.id !== id))
  //}

  if (!exercise?.history || !eating?.history) {
    return (
      <div className="icon-loading-middle-page">
        <img className="small-logo-nav loading-icon" 
            src={require("../images/florence-white-blue.png")} alt="Florence logo"/>
        <p>Carregando página...</p> 
      </div>
    )
  }

  //const exerciseHistoryFiltered = exercise.history.filter((food, i, arr) => arr.findIndex(obj2 => (obj2.id === food.id)) === i)
  //const mealsHistoryFiltered = eating.history.filter((food, i, arr) => arr.findIndex(obj2 => (obj2.id === food.id)) === i)

  //if (type === "all") {
  //  historyItems = historyItems.concat(mealsHistoryFiltered)
  //  historyItems = historyItems.concat(exerciseHistoryFiltered)
  //} else if (type === "eating") {
  //  historyItems = historyItems.concat(mealsHistoryFiltered)
  //} else if (type === "exercise") {
  //  historyItems = historyItems.concat(exerciseHistoryFiltered)
  //}

  const today = new Date()
  today.setHours(17,0,0,0)
  const sunday = nextSunday(today)
  const daysDifference = differenceInDays(sunday, new Date())
  const hoursDifference = differenceInHours(sunday, new Date())
  const minutesDifference = differenceInMinutes(sunday, new Date())

  let remainingTime = null

  if (daysDifference > 1) {
    remainingTime = `${daysDifference} dias restantes`
  } else if (daysDifference > 0) {
    remainingTime = `1 dia restante`
  } else if (hoursDifference > 0) {
    remainingTime = `${hoursDifference} horas restantes`
  } else if (minutesDifference > 1) {
    remainingTime = `${minutesDifference} minutos restantes`
  }

  let personalRecord = null
  if (league?.personal_best_score && league.personal_best_score > 1) {
    personalRecord = `Seu recorde pessoal: ${league.personal_best_score} pontos`
  }

  return (
    (!exercise?.history || !eating?.history) ? 
      <div className="icon-loading-middle-page">
        <img className="small-logo-nav loading-icon" 
            src={require("../images/florence-white-blue.png")} alt="Florence logo"/>
        <p>Carregando página...</p> 
      </div>
      :
      <>
        <div className={(tabletBreakpoint) ? "container-simple-tablet" : "container-simple"}>
          <Header 
            tabletBreakpoint={false} 
            menuItems="portal" 
            id={+cookies.get("userId")} 
            menuShow={true} 
            selected="league"
            sequenceLength={sequenceLength}
            hasObjectives={(eating && eating?.goals) ? eating.goals.length > 0 : false}
            league={(league?.is_in_current_league) ? league.is_in_current_league : false}
          />
        </div>
        <>
          <div className={(tabletBreakpoint) ? "container-simple-tablet" : "container-simple"}>

          <div className="">
            <p className="florence-title top-margin-s">
              Ranking
            </p>
            <p className="intra-page-title bottom-margin-xs">
              Semanal
            </p>
            {(league?.is_in_current_league && personalRecord) ?
            <p className="body bottom-margin-xxs ">
              {personalRecord}
            </p> : null }
            {(league?.is_in_current_league && remainingTime) ?
            <p className="body bottom-margin-xs secondary-color">
              {remainingTime}
            </p> : null }
          </div>

            {(location.state?.message) ?
              <div className="bottom-margin-m">
                <HighlightedMessage icon={Attention} type="warning" header="Atenção" body={location.state.message} />
              </div>
            : null }

            {(league?.is_in_current_league) ? (
              <div className="bottom-margin-l">
                <div className="calendar-history top-margin-m bottom-margin-m">
                  <WeeklyRanking
                    participants={league.league_rank}
                    userId={+cookies.get("userId")}
                  />
                </div>
              </div> ) : (
              <div>
                <div className="submit-column bottom-margin-xxl top-margin-m">
                  <img className="submission-image" src={Lazy} alt="No activity yet"/>
                <p className="body secondary-color" style={{textAlign: "center"}}>
                  Adicione uma refeição ou exercício para entrar no ranking dessa semana
                </p>
                </div>
              </div>
              )
            }



          </div>
        </>
      </>
  )
}
